import { render, staticRenderFns } from "./ProfileSettingsFromDetails.vue?vue&type=template&id=97fd27be&scoped=true"
import script from "./ProfileSettingsFromDetails.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsFromDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fd27be",
  null
  
)

export default component.exports